import React, { useEffect } from "react";
import { node, bool } from "prop-types";
import { motion } from "framer-motion";
import { useRouter } from "next/router";

import { ROUTES } from "@shared/routing/routes";

const PageTransition = ({ children, noAnimation }) => {
  const router = useRouter();

  useEffect(() => {
    if (router.pathname !== ROUTES.BASKET) {
      window.scrollTo({
        top: 0,
        left: 0,
      });
    }
  }, [router.pathname]);

  const complexVariants = {
    initial: { y: 100, opacity: 0 },
    exit: {
      opacity: 0,
      transition: {
        type: "tween",
        duration: 0.3,
        ease: "easeIn",
      },
    },
    animate: {
      y: 0,
      opacity: 1,
      transition: {
        type: "tween",
        duration: 0.3,
        ease: "easeIn",
        delay: 0.4,
      },
    },
  };

  const noAnimationVariant = {
    initial: { opacity: 1 },
    animate: { opacity: 1 },
    exit: { opacity: 1, transition: { duration: 0, type: "tween" } },
  };

  return (
    <>
      <motion.div
        animate="animate"
        className="relative z-1"
        exit="exit"
        initial="initial"
        variants={noAnimation ? noAnimationVariant : complexVariants}
      >
        {children}
      </motion.div>
    </>
  );
};

PageTransition.propTypes = {
  children: node,
  noAnimation: bool,
};

export default PageTransition;
